import React, { useEffect, useState, useContext, useRef } from "react";
import { useQuery } from "@apollo/client";
import {
  Typography,
  Stack,
  Box,
  Grid,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Paper,
  Avatar,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import { useDownloadExcel } from "react-export-table-to-excel";
//date picker
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
//Icons
import { SiMicrosoftexcel } from "react-icons/si";
import SearchIcon from "@mui/icons-material/Search";
//Srcs
import "../../Style/pagestyle.scss";
import FooterPagination from "../Include/FooterPagination";
import EmptyData from "../Include/EmptyData";
import LoadingPage from "../Include/LoadingPage";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import { SelectAcademicYear, SelectProgramme } from "../Include/DynamicSelect";
import { GET_STUDENT_TUITION_REPORT } from "../../Schema/Report";

export default function ExportTuitionReport({
  tableData,
  loading,
  paginationData,
  tableRef,
}) {
  // Change Language
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  //Export to excel
  //   const tableRef = useRef(null);
  //   const { onDownload } = useDownloadExcel({
  //     currentTableRef: tableRef.current,
  //     filename: "Staff-Information-Table",
  //     sheet: "Staff-Information",
  //   });

  return (
    <div className="page-container" style={{ display: "none" }}>
      <Box className="body-container">
        <TableContainer>
          <Table className="table" aria-label="simple table" ref={tableRef}>
            <TableHead className="header-row">
              <TableCell className="header-title-start">{t("no")}</TableCell>
              <TableCell className="header-title">Student ID</TableCell>
              <TableCell className="header-title">Full name</TableCell>
              <TableCell className="header-title">English name</TableCell>
              <TableCell className="header-title">Gender</TableCell>
              <TableCell className="header-title">Date of birth</TableCell>
              <TableCell className="header-title">Nationality</TableCell>
              <TableCell className="header-title">Programme name</TableCell>
              <TableCell className="header-title">Shift</TableCell>
              <TableCell className="header-title">Phone</TableCell>
              <TableCell className="header-title">Class name</TableCell>
              <TableCell className="header-title">Invoice number</TableCell>
              <TableCell className="header-title">Start date</TableCell>
              <TableCell className="header-title">End date</TableCell>
              <TableCell className="header-title">Paid date</TableCell>
              {/* <TableCell className="header-title" align="center">
                Income head
              </TableCell> */}
              <TableCell className="header-title">Tuition</TableCell>
              <TableCell className="header-title">Income</TableCell>
              <TableCell className="header-title">Computer</TableCell>
              <TableCell className="header-title">Dance</TableCell>
              <TableCell className="header-title">Music</TableCell>
              <TableCell className="header-title">Material</TableCell>
              <TableCell className="header-title">Meal service</TableCell>
              <TableCell className="header-title">School uniform</TableCell>
              <TableCell className="header-title">Summer class</TableCell>
              <TableCell className="header-title">service</TableCell>
              <TableCell className="header-title">Transportation</TableCell>
              <TableCell className="header-title">Trail one month</TableCell>
              <TableCell className="header-title">
                Transportation service
              </TableCell>
              <TableCell className="header-title">Admin fee</TableCell>
              <TableCell className="header-title">Total</TableCell>
              <TableCell className="header-title" align="center">
                Note
              </TableCell>
              <TableCell
                className="header-title-end"
                style={{
                  width: "5% !important",
                  textAlign: "center !important",
                  backgroundColor: "red !important",
                }}
              >
                Customer type
              </TableCell>
            </TableHead>
            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={12} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody component={Paper} className="body">
                    <TableRow className="body-row">
                      <TableCell colSpan={12} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="body">
                      {tableData?.map((row, index) => {
                        return (
                          <TableRow className={"body-row"} key={index}>
                            <TableCell className="body-cell-start">
                              {index + paginationData?.slNo}
                            </TableCell>
                            <TableCell className="body-cell">
                              {/* ="{String((row?.student_id).padStart(6, "0"))}" */}
                              ="
                              {String(
                                (row?.student_id
                                  ? row?.student_id
                                  : "0"
                                ).padStart(6, "0")
                              )}
                              "
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.lastName + " " + row?.firstName}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.englishName}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.gender}
                            </TableCell>
                            <TableCell className="body-cell">
                              {moment(row?.dob).format("YYYY-MM-DD")}
                            </TableCell>

                            <TableCell className="body-cell">
                              {row?.nationality}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.progarmmeName}
                            </TableCell>

                            <TableCell className="body-cell">
                              {row?.shiftName}
                            </TableCell>
                            <TableCell className="body-cell" align="center">
                              {row?.phone}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.className}
                            </TableCell>
                            <TableCell className="body-cell" align="center">
                              {row?.invoiceNumber}
                            </TableCell>
                            <TableCell className="body-cell">
                              {moment(row?.startDate).format("YYYY-MM-DD")}
                            </TableCell>

                            <TableCell className="body-cell">
                              {moment(row?.endDate).format("YYYY-MM-DD")}
                            </TableCell>
                            <TableCell className="body-cell">
                              {moment(row?.paidDate).format("YYYY-MM-DD")}
                            </TableCell>
                            {/* <TableCell className="body-cell">
                              <Stack direction="column">
                                {row?.incomeHead?.map((data, index2) => (
                                  <div
                                    className="income-head"
                                    direction="row"
                                    key={index2}
                                  >
                                    {data?.incomeName} :  {data?.total}
                                  </div>
                                ))}
                              </Stack>
                            </TableCell> */}
                            <TableCell className="body-cell">
                              {row?.Tuition}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.Income}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.Computer}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.Dance}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.Music}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.Material}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.MealService}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.SchoolUniform}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.SummerClass}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.service}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.Transportation}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.TrailOneMonth}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.TransportationService}
                            </TableCell>

                            <TableCell className="body-cell">
                              {row?.AdminFee}
                            </TableCell>
                            <TableCell className="body-cell">
                              {row?.total}
                            </TableCell>

                            <TableCell className="body-cell" align="center">
                              {row?.note}
                            </TableCell>
                            <TableCell className="body-cell-end">
                              <Stack direction="row" justifyContent="center">
                                <Box
                                  className="customer-type"
                                  align="center"
                                  style={{
                                    backgroundColor:
                                      row?.customerType === "Simple"
                                        ? "#0f81c2"
                                        : row?.customerType === "Special"
                                        ? "green"
                                        : row?.customerType === "Shareholder"
                                        ? "red"
                                        : "#F4D03F",
                                  }}
                                >
                                  {row?.customerType}
                                </Box>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
